module.exports = __webpack_public_path__ + "static/media/dietitian.7e2ac426.jpg";